import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

function onLoad(module, ...args) {
    module.onLoad(module, ...args);
}

const AirportShuttlePage = withInterstitial(import('./pages/AirportShuttlePage'), { onLoad });

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        component: ScrollToTopOnMount(AirportShuttlePage),
        exact: true,
        key: 'airportShuttle',
        path: '/airport-shuttles/:airportSlug',
    },
];
